import React, { useEffect, useState } from 'react';

function ComingSoon() {
  const [progress, setProgress] = useState(0);

  useEffect(() => {
    const handleContextMenu = (e) => { e.preventDefault(); return false; };
    const handleKeyDown = (e) => {
      if (
        e.key === 'F12' ||
        (e.ctrlKey && e.shiftKey && (e.key === 'I' || e.key === 'J')) ||
        (e.ctrlKey && e.key === 'U')
      ) { e.preventDefault(); return false; }
    };
    const handleCopy = (e) => { e.preventDefault(); return false; };
    const handleDragStart = (e) => { e.preventDefault(); return false; };

    document.addEventListener('contextmenu', handleContextMenu);
    document.addEventListener('keydown', handleKeyDown);
    document.addEventListener('copy', handleCopy);
    document.addEventListener('dragstart', handleDragStart);
    document.body.style.userSelect = 'none';
    document.body.style.webkitUserSelect = 'none';

    // Animate progress bar 0 → 68%
    let p = 0;
    const progressTimer = setInterval(() => {
      p += 0.4;
      if (p >= 68) { p = 68; clearInterval(progressTimer); }
      setProgress(p);
    }, 20);

    return () => {
      clearInterval(progressTimer);
      document.removeEventListener('contextmenu', handleContextMenu);
      document.removeEventListener('keydown', handleKeyDown);
      document.removeEventListener('copy', handleCopy);
      document.removeEventListener('dragstart', handleDragStart);
      document.body.style.userSelect = '';
      document.body.style.webkitUserSelect = '';
    };
  }, []);

  return (
    <div className="bg-black text-white overflow-x-hidden w-full min-h-screen flex flex-col">

      <style>{`
        img {
          pointer-events: none;
          user-select: none;
          -webkit-user-drag: none;
        }
        html, body {
          overflow-x: hidden;
          max-width: 100%;
        }
        @keyframes glow-pulse {
          0%, 100% { box-shadow: 0 0 24px 6px rgba(249,115,22,0.35); }
          50%       { box-shadow: 0 0 48px 16px rgba(249,115,22,0.6); }
        }
        @keyframes dot-bounce {
          0%, 80%, 100% { transform: scale(1);   opacity: 0.4; }
          40%            { transform: scale(1.5); opacity: 1;   }
        }
        @keyframes sparkle-spin {
          0%   { transform: rotate(0deg)   scale(1);   }
          50%  { transform: rotate(180deg) scale(1.3); }
          100% { transform: rotate(360deg) scale(1);   }
        }
        @keyframes clock-rotate {
          from { transform: rotate(0deg); }
          to   { transform: rotate(360deg); }
        }
        .clock-ring {
          animation: glow-pulse 2.5s ease-in-out infinite;
        }
        .sparkle {
          animation: sparkle-spin 3s ease-in-out infinite;
          display: inline-block;
        }
        .dot-0 { animation: dot-bounce 1.2s ease-in-out 0s   infinite; }
        .dot-1 { animation: dot-bounce 1.2s ease-in-out 0.2s infinite; }
        .dot-2 { animation: dot-bounce 1.2s ease-in-out 0.4s infinite; }
        .minute-hand {
          transform-origin: 32px 32px;
          animation: clock-rotate 6s linear infinite;
        }
        .hour-hand {
          transform-origin: 32px 32px;
          animation: clock-rotate 72s linear infinite;
        }
      `}</style>

      {/* Background stars — identical to Home.js */}
      <div className="fixed inset-0 overflow-hidden pointer-events-none">
        {[...Array(80)].map((_, i) => (
          <div
            key={i}
            className="absolute bg-white rounded-full opacity-40"
            style={{
              width:  Math.random() * 2 + 1 + 'px',
              height: Math.random() * 2 + 1 + 'px',
              top:    Math.random() * 100 + '%',
              left:   Math.random() * 100 + '%',
            }}
          />
        ))}
      </div>

      {/* Orange glow blobs — same as Home.js */}
      <div className="fixed inset-0 pointer-events-none opacity-10">
        <div className="absolute top-20 left-16 w-72 h-72 bg-orange-600 rounded-full blur-3xl" />
        <div className="absolute bottom-20 right-16 w-96 h-96 bg-amber-800 rounded-full blur-3xl" />
      </div>

      {/* Back button — top left like screenshot */}
      <div className="relative z-20 p-6">
        <button
          onClick={() => window.history.back()}
          className="flex items-center gap-2 px-4 py-2 rounded-full bg-white/10 backdrop-blur-md border border-white/20 text-white text-sm font-medium hover:bg-orange-500/20 hover:border-orange-500/50 transition-all duration-300"
        >
          <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10 19l-7-7m0 0l7-7m-7 7h18" />
          </svg>
          Back
        </button>
      </div>

      {/* ── Main centered content ── */}
      <div className="relative z-10 flex flex-col items-center justify-center flex-1 px-4 text-center pb-20">

        {/* Animated Clock icon */}
        <div className="clock-ring w-28 h-28 rounded-full border-2 border-orange-500 flex items-center justify-center mb-10">
          <svg width="64" height="64" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle cx="32" cy="32" r="27" stroke="#f97316" strokeWidth="2" opacity="0.3" />
            {/* Hour markers */}
            {[0,30,60,90,120,150,180,210,240,270,300,330].map((deg, i) => {
              const rad = (deg - 90) * Math.PI / 180;
              const inner = i % 3 === 0 ? 21 : 23;
              return (
                <line
                  key={i}
                  x1={32 + inner * Math.cos(rad)}
                  y1={32 + inner * Math.sin(rad)}
                  x2={32 + 26 * Math.cos(rad)}
                  y2={32 + 26 * Math.sin(rad)}
                  stroke="#f97316"
                  strokeWidth={i % 3 === 0 ? 2 : 1}
                  strokeLinecap="round"
                  opacity={i % 3 === 0 ? 1 : 0.4}
                />
              );
            })}
            {/* Hour hand */}
            <line className="hour-hand" x1="32" y1="32" x2="32" y2="20" stroke="white" strokeWidth="3" strokeLinecap="round" />
            {/* Minute hand */}
            <line className="minute-hand" x1="32" y1="32" x2="32" y2="14" stroke="#f97316" strokeWidth="2" strokeLinecap="round" />
            {/* Center dot */}
            <circle cx="32" cy="32" r="3" fill="#f97316" />
          </svg>
        </div>

        {/* "Coming Soon" heading with sparkles */}
        <h1 className="text-5xl sm:text-7xl font-extrabold mb-5 tracking-tight">
          <span className="sparkle text-orange-400 text-3xl mr-3">✦</span>
          <span
            style={{
              background: 'linear-gradient(90deg, #f97316 0%, #ffffff 50%, #f97316 100%)',
              WebkitBackgroundClip: 'text',
              WebkitTextFillColor: 'transparent',
              backgroundClip: 'text',
            }}
          >
            Coming Soon
          </span>
          <span className="sparkle text-orange-400 text-3xl ml-3">✦</span>
        </h1>

        {/* Sub-text */}
        <p className="text-white font-semibold text-lg sm:text-xl mb-4">
          We're working hard to bring you something amazing!
        </p>
        <p className="text-white/50 text-sm sm:text-base max-w-md leading-relaxed mb-12">
          This feature is currently under development and will be available soon. Stay tuned for updates!
        </p>

        {/* Progress bar */}
        <div className="w-full max-w-sm mb-3">
          <div className="h-2.5 bg-white/10 rounded-full overflow-hidden">
            <div
              className="h-full rounded-full transition-all duration-100"
              style={{
                width: `${progress}%`,
                background: 'linear-gradient(90deg, #f97316, #fb923c, #fdba74)',
                boxShadow: '0 0 10px rgba(249,115,22,0.6)',
              }}
            />
          </div>
        </div>
        <p className="text-white/40 text-xs tracking-widest uppercase mb-10">
          In Progress...
        </p>

        {/* Animated dots */}
        <div className="flex items-center gap-3">
          <div className="dot-0 w-3 h-3 rounded-full bg-orange-500" />
          <div className="dot-1 w-3 h-3 rounded-full bg-orange-400" />
          <div className="dot-2 w-3 h-3 rounded-full bg-amber-400" />
        </div>

      </div>
    </div>
  );
}

export default ComingSoon;